module.exports = __webpack_public_path__ + "static/back-end-2cf830528773aa3f83af790d2f567131.svg";